// removed by extract-text-webpack-plugin
module.exports = {"formButtons":"_20T22ParEg-n-hZqNcfHlO","formButtonsSticked":"yis2uPan5XAL-ECXKFTM7","contentPadder":"xgeh19aHZ1GGfOFvG6REf"};


//////////////////
// WEBPACK FOOTER
// ./app/client/bundles/EventSubmission/components/FormButtons.scss
// module id = 1509
// module chunks = 0